"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Line", {
    enumerable: true,
    get: function() {
        return _SkeletonLine.SkeletonLine;
    }
});
const _SkeletonLine = require("./SkeletonLine/SkeletonLine");

//# sourceMappingURL=index.js.map